import { type MeterPowerAnalysisFormValues } from "../types/meterPowerAnalysisFormValues"

const DEFAULT_METER_POINT_PMAX = {
    meterPointId: "",
    providerCalendarId: null,
    user: {
        email: null,
        firstName: "",
        lastName: "",
        accountNumber: null,
    },
}

export const METER_POWER_ANALYSIS_DEFAULT_FORM_VALUES: MeterPowerAnalysisFormValues = {
    affiliateCode: null,
    rewardCode: null,
    productCode: null,
    pmaxToken: null,
    currentSubscribedMaxPower: null,
    recommendedSubscribedMaxPower: null,
    yearlyProfitAmountCents: null,
    isFromDashboard: false,
    errorCode: null,
    ...DEFAULT_METER_POINT_PMAX,
}
